import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { Router } from '@angular/router';
import { MappingService } from 'src/app/services/mapping.service';
import { CurriculumStore } from 'src/app/stores/resources/curriculum.store';
import { ResourceStore } from 'src/app/stores/resources/resource.store';

@Component({
  selector: 'app-add-program-level-lesson',
  templateUrl: './add-program-level-lesson.component.html',
  styleUrls: ['./add-program-level-lesson.component.scss']
})
export class AddProgramLevelLessonComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Add New Lesson"

  form: FormGroup;
  lesson: AbstractControl;

  LESSON_LIST: any;
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddProgramLevelLessonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: CurriculumStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private resource: ResourceStore,
    private route: Router,
  ) { }

  async ngOnInit() {
    const { LESSON_KEY } = this.data;
    this.form = this.fb.group({
      lesson: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
    })
    this.lesson = this.form.controls['lesson'];
    const LESSON_LIST = await this.resource.fetchListArray(COLLECTION_NAME.LESSON, "name");
    const LESSON_LIST_DATA = LESSON_LIST.filter(m => !LESSON_KEY.includes(m.key))
    this.LESSON_LIST = MappingService.autoComplete(this.lesson, LESSON_LIST_DATA, "name");

  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { PROGRAM_KEY, LEVEL_KEY } = this.data;
      const { user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { lesson } = f;
      const validLesson = await this.ds.programRef().doc(PROGRAM_KEY)
        .collection('levels').doc(LEVEL_KEY)
        .collection('lessons').doc(lesson.key).get().toPromise();
      if (validLesson.exists) {
        alert("Lesson is already assigned to level.")
        this.inputEl.nativeElement.focus();
        return;
      }
      this.store.addLesson(lesson, LEVEL_KEY, PROGRAM_KEY, user.uid, (success, res) => {
        if (success) {
          this.data.LESSON_KEY.push(lesson.key)
          this.snackBar.open("Lesson has been added to level successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close();
        }
      })
    }
  }
}